import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PartnersService } from './partners.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [PartnersService],
})
export class PartnersModule {}
